module.exports = __webpack_public_path__ + "img/admin_login.5b44e20a.png";